import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components';
import { formatDate } from '../../../models/functions/format-date';
import { useRootStore } from '../../../providers/root-store-provider';
import { Button } from '../form/button/button';
import { Confirm } from '../confirm/confirm';

export const Bar: React.FC = observer(() => {
    const { t } = useTranslation();
    const theme = useTheme();
    const rootStore = useRootStore();
    const { stripeStore, authStore } = rootStore;
    const { userProfile } = authStore;
    const subscription = userProfile?.subscription;
    const myTariff = authStore.userProfile?.subscription;
    const hasAppleSubscription = authStore.userHasAppleSubscription;

    if (rootStore.themeStore.showBar && userProfile?.subscriptionEndDate) {
        return (
            <div
                className="sticky top-0 z-[902] flex min-h-bar items-center justify-center bg-status-negative/20 px-vsmall py-vsmall text-small font-bold leading-small text-neutral-white shadow-[inset_0_-0.1rem_0.4rem_var(--bar-shadow)] lg:py-0 vl:sticky vl:top-0 vl:min-h-bar"
                style={{ '--bar-shadow': theme.palette.color.negative.main } as React.CSSProperties}
            >
                <div className="flex flex-col items-center gap-vsmall text-center md:flex-row md:gap-medium">
                    <div>
                        <Trans
                            i18nKey="layout.subscription.subscriptionEndsAt"
                            values={{ tariff: subscription, date: formatDate(userProfile?.subscriptionEndDate) }}
                            components={{
                                tariff: <span className="font-bold capitalize" />,
                            }}
                        />
                        {userProfile?.scheduledSubscription ? (
                            <> {t(`pages.profile.settings.subscription.activeTariff.text.extended.${myTariff}`)}</>
                        ) : null}
                        {hasAppleSubscription ? <> {t('layout.subscription.managedInAppStore')}</> : null}
                    </div>
                    {hasAppleSubscription ? null : (
                        <Confirm
                            isProcessing={stripeStore.loading}
                            onConfirm={async () => {
                                await stripeStore.reactivateSubscription();
                            }}
                            title={t('pages.profile.confirm.continueInPremium')}
                            cancelTitle={t('pages.profile.confirm.continueInPremiumCancel')}
                            confirmTitle={t('pages.profile.confirm.continueInPremiumConfirm')}
                            variant="positive"
                            position="bottom"
                        >
                            <Button size="xsmall" variant="white">
                                <Trans
                                    i18nKey="layout.subscription.continue"
                                    values={{
                                        tariff: subscription,
                                    }}
                                    components={{
                                        tariff: <span className="font-bold capitalize" />,
                                    }}
                                />
                            </Button>
                        </Confirm>
                    )}
                </div>
            </div>
        );
    }

    // Free users are redirected to pricing page - they never see this component
    return null;
});
